import { FOOTER_LINKS, LEGAL_PATHS } from "./paths.js";
import { useSite } from "./site.js";

/**
 * The site footer on every donor page (GH-812): Terms · Privacy · Disclosures · Support.
 *
 * Rendered once, by `main.tsx`, under whichever page the path selected, so no page can forget it
 * and no page under another branch's edit has to carry it. Plain links: the donor web has no
 * client router, and a full navigation is what a legal link should be anyway.
 */
export function SiteFooter() {
  const { organizationLegalName, productName } = useSite();
  return (
    <footer className="site-footer">
      <nav aria-label="Legal">
        <ul className="site-footer__links">
          {FOOTER_LINKS.map(({ key, label }) => (
            <li key={key}>
              <a href={LEGAL_PATHS[key]}>{label}</a>
            </li>
          ))}
        </ul>
      </nav>
      <p className="site-footer__entity">
        {productName} · {organizationLegalName}
      </p>
    </footer>
  );
}
